import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FilePondModule } from 'ngx-filepond';

import { SharedModule } from '@teem/shared/shared.module';
import { CoreModule } from '@teem/core/core.module';

import { ServiceGridComponent } from '@teem/service-module/components/service-grid/service-grid.component';
import { EditServicesComponent } from '@teem/service-module/modals/edit-services/edit-services.component';
import { AddServicesComponent } from '@teem/service-module/modals/add-services/add-services.component';
import { StoreServicesRoutingModule } from '@teem/service-module/store-services-routing.module';
import { StoreServicesComponent } from '@teem/service-module/store-services.component';
import { ImportServiceModalComponent } from '@teem/service-module/modals/import-service-modal/import-service-modal.component';


@NgModule({
  declarations: [
    StoreServicesComponent,
    ServiceGridComponent,
    AddServicesComponent,
    EditServicesComponent,
    ImportServiceModalComponent
  ],
  entryComponents: [
    AddServicesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    SharedModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    NgbModule,
    FilePondModule,
    StoreServicesRoutingModule,
  ]
})
export class StoreServicesModule { }
